import { appEntityPageModule } from './appExtensions';
import { convertedLegacyPlugins } from './legacyPlugins';
import { nativeEntityOverrideModules } from './nativeOverrides';
import { pluginWrapperModules } from './pluginWrappers';

export { convertedLegacyPlugins } from './legacyPlugins';

/** Everything that shapes the catalog entity page. */
export const entityPageFeatures = [
  ...nativeEntityOverrideModules,
  ...pluginWrapperModules,
  appEntityPageModule,
  ...convertedLegacyPlugins,
];
